import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const EmailSignupModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "EmailSignupModalContainer" */
      './EmailSignupModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
